module.exports = {
  fi: {
    '0': {
      a: 'What Chatgpt can do?',
      b: 'What Chatgpt cannot do?',
      c: 'How do LLMs work?',
      d: 'Efficiency, Cost and Robustness',
    },
    '1': {
      a: 'Negative Feedback Loops',
      b: 'Data Ownership',
      c: 'DeepFakes',
      d: 'Bubbles and Narrative Setting',
      e: 'AI for Loans? Hiring? Law and Law Enforcement?',
    },
    '2': {
      a: 'What is Machine Learning?',
      b: 'Supervised Learning',
      c: '3 type of errors',
    },
    '3': {
      a: 'The Alignment Problem',
      b: '(AI)gorithms and Design',
      c: 'Precision and Recall',
      d: 'Cost of Data Collection',
      e: 'Using Domain Knowledge',
    },
    '4': {
      a: 'Math',
      b: 'Coding',
      c: 'ML',
      d: 'Cool Research Directions',
    },
  },
  en: {
    '0': {
      a: 'Supervised Learning',
      b: 'The Alignment Problem',
      c: 'Designing AI Systems',
    },
    '1': {
      a: 'Model Selection and Evaluation',
      b: 'Types of Errors',
      c: 'Deceptive Datasets and Negative Feedback Loops',
    },
    '2': {
      a: 'Google Search and Juxtaposition',
      b: 'Intuition: Large Language Models(LLMs)',
      c: 'LLM Use-Cases',
    },
  },
  zh: {
    '0': {
      a: '基础知识',
      b: 'Web 应用的基础设施',
    },
    '1': {
      a: 'React 简介',
      b: 'JavaScript',
      c: '组件状态，事件处理',
      d: '深入React 应用调试',
    },
    '2': {
      a: '从渲染集合到模块学习',
      b: '表单',
      c: '从服务器获取数据',
      d: '在服务端将数据Alert出来',
      e: '给React应用加点样式',
    },
    '3': {
      a: 'Node.js 与 Express',
      b: '把应用部署到网上',
      c: '将数据存入MongoDB',
      d: 'ESLint与代码检查',
    },
    '4': {
      a: '从后端结构到测试入门',
      b: '测试后端应用',
      c: '用户管理',
      d: '密钥认证',
    },
    '5': {
      a: '完成前台的登录功能',
      b: 'props.children 与 proptypes',
      c: '测试React 应用',
      d: '端到端测试',
    },
    '6': {
      a: 'Flux架构与Redux',
      b: '再来点 reducers',
      c: '在Redux应用中与后端通信',
      d: 'connect方法',
    },
    '7': {
      a: 'React-router',
      b: '自定义 hooks',
      c: '样式进阶',
      d: 'Webpack',
      e: '各种各样的Class components',
      f: '练习：扩展你的博客列表',
    },
    '8': {
      a: 'GraphQL服务器',
      b: 'React 与 GraphQL',
      c: '数据库与用户管理',
      d: '登录与更新缓存',
      e: 'Fragments 与 subscriptions',
    },
    '9': {
      a: '背景与介绍',
      b: 'Typescript的一小步',
      c: 'Typescript版的express应用',
      d: '利用Typescript编写React应用',
    },
    '10': {
      a: 'React Native 介绍',
      b: 'React Native 入门',
      c: '与服务端通信',
      d: '测试与扩展我们的应用',
    },
    '11': {
      a: 'CI/CD 简介',
      b: '开始认识 GitHub Actions 吧',
      c: '部署',
      d: '保持健康状态',
      e: '再扩展一下',
    },
  },
  es: {
    '0': {
      a: 'Información general',
      b: 'Fundamentos de las aplicaiones web',
    },
    '1': {
      a: 'Introducción a React',
      b: 'JavaScript',
      c: 'Estado del componente, controladores de eventos',
      d: 'Un estado más complejo, depurando aplicaciones React',
    },
    '2': {
      a: 'Renderizando una colección, módulos',
      b: 'Formularios',
      c: 'Obteniendo datos del servidor',
      d: 'Alterando datos en el servidor',
      e: 'Agregar estilos a la aplicación React',
    },
    '3': {
      a: 'Node.js y Express',
      b: 'Implementación de la aplicación en Internet',
      c: 'Guardando datos en MongoDB',
      d: 'Validación y ESLint',
    },
    '4': {
      a: 'Estructura de la aplicación backend, introducción a las pruebas',
      b: 'Porbando el backend',
      c: 'Administración de usuarios',
      d: 'Autenticación de token',
    },
    '5': {
      a: 'Iniciar sesión en la interfaz',
      b: 'props.children y proptypes',
      c: 'Probando aplicaciones React',
      d: 'Pruebas de extremo a extremo',
    },
    '6': {
      a: 'Flux-architecture y Redux',
      b: 'Muchos reducers',
      c: 'Comunicarse con el servidor en una aplicación redux',
      d: 'conectar',
    },
    '7': {
      a: 'React-router',
      b: 'Hooks personalizados',
      c: 'Más sobre estilos',
      d: 'Webpack',
      e: 'Componentes de clases, varios',
      f: 'Ejercicios: ampliar la lista de blogs',
    },
    '8': {
      a: 'Servidor GraphQL',
      b: 'React y GraphQL',
      c: 'Administración de bases de datos y usuarios',
      d: 'Iniciar sesión y actualizar la caché',
      e: 'Fragmentos y suscripciones',
    },
    '9': {
      a: 'Antecedentes e introducción',
      b: 'Primeros pasos con Typescript',
      c: 'Escribiendo la aplicación express',
      d: 'React con tipos',
    },
    '10': {
      a: 'Introducción a React Native',
      b: 'Conceptos básicos de React Native',
      c: 'Comunicandose con el servidor',
      d: 'Probar y ampliar nuestra aplicación',
    },
    '11': {
      a: 'Introducción a CI/CD',
      b: 'Introducción a las acciones de Github',
      c: 'Despliegue',
      d: 'Manteniéndose verde',
      e: 'Expandiéndose aún más'
    },
  },
};
